import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import logger from 'redux-logger';

import reducers from './reducers';
import { isProductionBuild } from '../utils';

let middleware = [];

if (isProductionBuild()) {
  middleware = [thunk];
} else {
  middleware = [
    // logger,
    thunk,
  ];
}

const INITIAL_STATE = {};

const store = createStore(
  reducers,
  INITIAL_STATE,
  composeWithDevTools(applyMiddleware(...middleware)),
);

export default store;
